module.exports = __webpack_public_path__ + "static/media/02_05_02.ff38c02a.png";